import { render, staticRenderFns } from "./PageSorteio.vue?vue&type=template&id=3287cced&scoped=true"
import script from "./PageSorteio.vue?vue&type=script&lang=js"
export * from "./PageSorteio.vue?vue&type=script&lang=js"
import style0 from "./PageSorteio.vue?vue&type=style&index=0&id=3287cced&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3287cced",
  null
  
)

export default component.exports